import React, { useState, useEffect } from "react";
import { Prompt } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { authConstants, generalConstants } from "_constants";
import { authAction } from "actions";
import { history, validatePassword } from "_util/_helper";
import { Loading, SubmitButton, CancelButton, TextField } from "components/general";
import { toast } from "react-toastify";

import { AdminMenubar, AdminUserInfo, AdminSectionbar, AdminFooter } from "components/admin";
import { PageContainer, LeftContainer, RightContainer, ContentContainer } from "components/layout";
import ProgressiveRejectDebouncer from "_util/debouncers/ProgressiveRejectDebouncer";

export const ChangePasswordPage = () => {
	const initForm = {
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
	};

	const loggedIn = useSelector(({ auth }) => auth.loggedIn);
	const changePasswordRequesting = useSelector(({ auth }) => auth.changePasswordRequesting);
	const changePasswordResult = useSelector(({ auth }) => auth.changePasswordResult);

	const [formData, setFormData] = useState(initForm);
	const [isChanged, setIsChanged] = useState(false);
	const dispatch = useDispatch();
	const [debouncer] = useState(() => new ProgressiveRejectDebouncer(2 * 1000));
	const [initialized, setInitialized] = useState(false);

	const handleChange = ({ key, value }) => {
		setFormData({ ...formData, [key]: value });
		setIsChanged(true);
	};

	const handleBack = () => {
		history.goBack();
	};

	useEffect(() => {
		if (loggedIn) {
			dispatch({ type: authConstants.type.CHANGE_PASSWORD_INIT });
		}
		setInitialized(true);
	}, [dispatch]);

	useEffect(() => {
		if (initialized) {
			if (!changePasswordRequesting && changePasswordResult) {
				setIsChanged(false);
				history.goBack();
			}
		}
	}, [changePasswordRequesting, changePasswordResult, initialized]);

	const handleSubmit = () => {
		if (!formData.currentPassword) {
			toast.error("請填寫現有密碼");
			return;
		}

		if (!formData.newPassword) {
			toast.error("請填寫新密碼");
			return;
		}

		if (!formData.confirmPassword) {
			toast.error("請填寫再次輸入新密碼");
			return;
		}

		if (formData.newPassword !== formData.confirmPassword) {
			toast.error("確認密碼不匹配");
			return;
		}

		const message = validatePassword(formData.newPassword, formData.currentPassword);
		if (message) {
			toast.error(message);
			return;
		}

		if (!debouncer.token()) {
			toast.error(`請稍後再試`);
			return;
		}
		dispatch(authAction.changePassword({ password: formData.currentPassword, confirmPassword: formData.newPassword }));
	};

	return (
		<>
			{!!changePasswordRequesting && <Loading />}
			<Prompt when={isChanged} message="你有未儲存的變更，確定不儲存下離開？" />
			<PageContainer>
				<LeftContainer>
					<AdminMenubar section={generalConstants.NAV_TAB.CHANGE_PASSWORD.key} />{" "}
				</LeftContainer>
				<RightContainer>
					<AdminUserInfo />
					<AdminSectionbar label={generalConstants.TAB_NAME.CHANGE_PASSWORD} title={generalConstants.NAV_TAB.CHANGE_PASSWORD.key} />
					<ContentContainer>
						<RowInBlock>
							<ContentLeft>
								<TitleFieldLabel>- 更改密碼</TitleFieldLabel>
								<Block style={{ width: "90%" }} marginTop="0">
									<TextFieldLabel>現有密碼</TextFieldLabel>
									<TextField
										placeholder="現有密碼"
										type="password"
										value={formData.currentPassword}
										name="currentPassword"
										handleChange={handleChange}
									/>
								</Block>
								<Block style={{ width: "90%" }} marginTop="19px">
									<TextFieldLabel>新密碼</TextFieldLabel>
									<TextField
										placeholder="新密碼"
										type="password"
										value={formData.newPassword}
										name="newPassword"
										handleChange={handleChange}
									/>
								</Block>
								<Block style={{ width: "90%" }} marginTop="19px">
									<TextFieldLabel>請再次輸入新密碼</TextFieldLabel>
									<TextField
										placeholder="請再次輸入新密碼"
										type="password"
										value={formData.confirmPassword}
										name="confirmPassword"
										handleChange={handleChange}
									/>
								</Block>
							</ContentLeft>

							<ContentRight></ContentRight>
						</RowInBlock>
						<RowInBlock marginTop={"10px"} style={{ justifyContent: "flex-end" }}>
							<CancelButton label={"取消"} style={{ marginRight: "15px" }} handleOnClick={handleBack} />
							<SubmitButton label={"確認"} handleOnClick={handleSubmit} active={isChanged && !changePasswordRequesting} />
						</RowInBlock>
					</ContentContainer>
					<AdminFooter></AdminFooter>
				</RightContainer>
			</PageContainer>
		</>
	);
};

const ContentLeft = styled.div`
	flex: 0 0 400px;
	min-height: 400px;
	padding-left: 10px;
	max-width: 220px;
`;

const ContentRight = styled.div`
	flex: 1;
	padding-left: 20px;
`;

const Block = styled.div`
	margin-top: ${(props) => props.marginTop || "40px"};
	flex-direction: column;
`;

const RowInBlock = styled.div`
	display: flex;
	margin-bottom: ${(props) => props.marginBottom || "10px"};
	flex-direction: row;
`;

const TextFieldLabel = styled.div`
	color: black;
	font-size: 13px;
	line-height: 1.5;
	font-weight: bold;
	margin-bottom: 10px;
`;
const TitleFieldLabel = styled.div`
	color: #333399;
	font-size: 14px;
	line-height: 1.5;
	font-weight: bold;
	margin-bottom: 10px;
`;
